<template>
    <vs-card>
        <h4 class="mb-4">Teachers</h4>
        <div class="cstm_vuexy_table table-responsive">
            <table class="w-full">
                <thead>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Courses</th>
                        <th style="width: 50px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(eachData, index) in students" :key="index">
                        <td>
                            {{ eachData.basic_details.first_name }}
                        </td>
                        <td>
                            {{ eachData.basic_details.last_name }}
                        </td>
                        <td>
                            {{ eachData.basic_details.email.email }}
                        </td>
                        <td>
                            {{ eachData.basic_details.phone.phone }}
                        </td>
                        <td>
                            <span class="material-icons-outlined cursor-pointer" @click="courseList(eachData.basic_details.operation_user_id)">library_books</span>
                        </td>
                        <!-- <td>
                            <vs-dropdown>
                                <vs-button class="btn-drop" type="flat" icon="more_vert"></vs-button>
                                <vs-dropdown-menu>
                                    <vs-dropdown-item>
                                        Edit
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        Delete
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </td> -->
                    </tr>
                </tbody>
            </table>
      <pagination
        style="float: right"
        :meta="meta"
        @page-change="handlePageChange"
      />
        </div>
        <div v-if="courseListModel">
      <vs-popup
        class="holamundo"
        title="Courses"
        :active.sync="courseListModel"
      >
      <div
        style="max-height: 250px; overflow: auto"
        class="vertical_scrollbar horizontal_scrollbar"
        @scroll="detectsScrollLength()"
        ref="element"
      >
        <div class="cstm_vuexy_table table-responsive">
          <table class="w-full">
            <tbody>
              <tr v-for="(eachData, index) in courses" :key="index">
                <td>{{ eachData.name }}</td>
              </tr>
              <tr v-if="courses.length==0" class="text-center">
                <td>No Courses found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </vs-popup>
    </div>
    </vs-card>
</template>

<script>
import {studentListFromStudentProfile, courseByTeacher} from '@/api/student.js'
import Pagination from '@/components/common/pagination'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      courseListModel:false,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      course_meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },

      students: [],
      courses: [],
      user_id:null
    }
  },
  mounted () {
    // this.fetchTeachers()
  },
  methods: {
    handlePageChange (page) {
      this.meta.current_page = page || 1

      setTimeout(() => {
        this.fetchTeachers()
      }, 0)
    },
    async detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight  &&  this.course_meta.has_next
      ) {
        this.meta.current_page =  this.meta.current_page + 1

        this.loadMore()
      }
    },
    async loadMore () {
      const payload = {
        user_id:this.user_id,
        limit:10
      }
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const response = await courseByTeacher(localStorage.getItem('customer_id'), this.$route.params.client_id, this.course_meta.current_page, payload)
        this.$vs.loading.close()
        this.courses.push(...response.data.data.courses)
        this.meta = response.data.data.meta
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    async courseList (id) {
      this.courseListModel = true
      this.user_id = id
      this.fetchCourse()
    },
    async fetchCourse () {
      const payload = {
        user_id:this.user_id,
        limit:10
      }

      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        console.log(localStorage.getItem('customer_id'), this.$route.params.client_id, this.course_meta.current_page, payload)
        const response = await courseByTeacher(localStorage.getItem('customer_id'), this.$route.params.client_id, this.course_meta.current_page, payload)
        this.$vs.loading.close()
        this.courses = response.data.data.courses
        this.meta = response.data.data.meta
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    async fetchTeachers () {
      const payload = {
        limit:10
      }

      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const response = await studentListFromStudentProfile(localStorage.getItem('customer_id'), this.$route.params.client_id, this.meta.current_page, payload)
        this.$vs.loading.close()
        this.students = response.data.data.operationalUser
        this.meta = response.data.data.meta
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    }
  }
}
</script>
